<template>
  <div class="v-application"><!-- v-application is used because the vuetify component styles only apply when the component lies under .v-application -->
    <v-snackbar
      v-model="isVisible"
      :color="currentStatus"
      location="bottom center"
    >
      <div
        v-for="text in currentTextArray"
        :key="text"
      >
        {{ text }}
      </div>
    </v-snackbar>
  </div>
</template>

<script setup lang="ts">
import { useGlobalSnackbar } from '../../../composables/useGlobalSnackbar';

const { isVisible, currentStatus, currentTextArray } = useGlobalSnackbar();
</script>
